var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inIframe)?_c('button',{staticClass:"sidebar-button",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"material-icons"},[_vm._v("menu")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }